export default defineNuxtRouteMiddleware((to) => {
  if (to.path !== '/login') {
    const { $i18n } = useNuxtApp();
    const { state } = useUser();
    switch (state.value.profile.locale) {
      case 'en':
        $i18n.setLocale('en');
        break;
      default:
        $i18n.setLocale('ja');
        break;
    }
  }
});
